import { Button } from '@mui/material';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Text } from '../../../components/common/Texts';
import LazyImg from '../../acropolisCommon/components/LazyImg';
import parse from 'html-react-parser';

const Card = (props) => {
    const { values } = props;

    // FUNCTIONS
    const sanitizerHtml = (html) => {
        const string = 'src="/';
        const regex = new RegExp(string, 'g');
        return html.replace(regex, 'src="');
    };

    const verMasBtns = values.product_line === 'Diplomados' 
                        || values.product_line === 'Workshops' 
                        || values.product_line === 'Especialización Online' 
                        || values.product_line === 'Certificaciones'

    const masInfoBtns = values.product_line !== 'Diplomados' 
                        && values.product_line !== 'Certificaciones'
                        && values.product_line !== 'Major'
                        && values.product_line !== 'Doctorado'
                        && values.product_line !== 'Maestría'

    return (
        <CardWrapper title={values.nombre}>
            <LazyImg
                src={values.image || values.imagen}
                height="102px"
                width="100%"
                borderRadius="20px 20px 0 0"
                backgroundColor="#f1f1f1"
            />
            <Body>
                <Title fontSize="18px" fontWeight="700">
                    {values.name || values.nombre}
                </Title>
                <BodyDescription>
                    <Text color="#949494">
                        {parse(sanitizerHtml(values?.description))}
                    </Text>
                </BodyDescription>
            </Body>

            <Footer>
                { verMasBtns && (
                        <Button
                            onClick={() => window.open(values?.nueva_url || '#')}
                            color="primary"
                        >
                            Ver más
                        </Button>
                    ) 
                }
                { 
                    !verMasBtns && (
                        <Button
                            onClick={() => window.open(values?.url || '#')}
                            color="primary"
                        >
                            Contactar Asesor
                        </Button>
                    )
                }
                {
                    masInfoBtns && (
                        <Button
                            onClick={() => window.open(values?.url || '#')}
                            variant='outlined'
                        >
                            {values.product_line === 'Workshops' ? 'Inscribirme' : 'Más información'}
                        </Button>
                    )
                }
            </Footer>
        </CardWrapper>
    );
};

export default Card;

const CardWrapper = styled.div`
    margin-top: 20px;
    display: grid;
    grid-template-rows: 102px auto 78px;
    width: 323px;
    height: auto;
    background: #ffffff;
    border: 1px solid #f1f1f1;
    box-shadow:
        0px 4px 6px -4px rgba(24, 39, 75, 0.12),
        0px 8px 8px -4px rgba(24, 39, 75, 0.08);
    border-radius: 20px;
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: .5;
  }
  100% {
    opacity: 1;
  }
`;

const Body = styled.div`
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    overflow: hidden;
    max-width: 100%;
`;

const BodyDescription = styled.div`
    max-height: 143px;
    overflow-y: auto;
    overflow-x: hidden;
    word-wrap: break-word;

    * {
        max-width: 100% !important;
        box-sizing: border-box !important;
    }
`;

const Footer = styled.div`
    height: 78px;
    background-color: #fafafa;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 22px;
`;

const Title = styled(Text)`
    width: 280px;
    /* white-space: nowrap; */
    /* text-overflow: ellipsis; */
    overflow: hidden;
`;
